import React, { useContext, useEffect } from "react";
import charticon from "../../assets/icons/Path 23145.svg";
import Prediction from "../../assets/icons/Prediction.png";
import PredictionTable from "../../components/PridictionComp/predictionTable";
import CountryListingCom from "../../components/PridictionComp/countryListingCom";
import ElectionTypeComp from "../../components/PridictionComp/electionTypeComp";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserPrediction } from "../../redux/actions/pollingAction";
import { setStep } from "../../context/predictionFlow/predictionHelpers";
import PredictionStepper from "./predictionStepper";
import CustomStepper from "./CustomStepper";

const PredictionActions = ({
  onNewPrediction,
  navigate,
  prediction,
  goToPredictionTable,
  handleGoToLivePredictions,
}) => (
  <div className="md:flex justify-between items-center w-full flex-wrap my-2 md:my-0 p-2">
    {}
    <div className="md:flex gap-2 my-2 md:my-0">
      {[
        // { name: "Completed Predictions" },
        { name: "My Live Predictions", onClick: handleGoToLivePredictions },
        {
          name: "Followed Predictions",
          path: "/prediction/followed_prediction",
        },
      ]?.map((label, index) => (
        <div
          key={index}
          className={` text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center my-2 md:my-0 max-w-[15rem] ${
            label?.name === "My Live Predictions" &&
            !prediction.newPrediction &&
            "bg-[#E60800] text-white"
          }`}
          onClick={() =>
            label?.onClick ? label.onClick() : navigate(label.path)
          }
        >
          <img
            src={
              label?.name === "My Live Predictions"
                ? !prediction.newPrediction
                  ? Prediction
                  : charticon
                : charticon
            }
            alt="chart-icon"
            width={12}
          />
          {label?.name}
        </div>
      ))}
    </div>
    {onNewPrediction && (
      <div
        className={`text-[12px] border p-2 rounded-2xl cursor-pointer hover:shadow-sm transition-all flex gap-2 items-center max-w-[15rem] ${"bg-[#012169] text-white"}`}
        onClick={onNewPrediction}
      >
        <img src={Prediction} alt="chart-icon" width={12} />
        New Prediction
      </div>
    )}
  </div>
);
const PredictionListing = () => {
  const { prediction, setPrediction, resetPrediction } =
    useContext(PredictionContext);
  const navigate = useNavigate();
  const isVerified = localStorage.getItem("accessToken");
  useEffect(() => {
    if (!isVerified) {
      navigate("/login");
    }
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserPrediction());
  }, []);

  const { PredictionListingResponse } = useSelector((state) => state.pollWeb);
  const handleNewPrediction = () => {
    setPrediction({ ...prediction, newPrediction: true });
  };
  const renderStep = () => {
    if (!prediction.newPrediction) {
      return <PredictionTable data={PredictionListingResponse} />;
    }

    if (!prediction.selectCountry) {
      return <CountryListingCom />;
    }
    if (
      !prediction.electionTypeData?.prediction ||
      !prediction.electionTypeData?.type
    ) {
      return <ElectionTypeComp />;
    }
  };

  // ⏮️ Handle back to listing view
  const handleGoToLivePredictions = () => {
    resetPrediction(); // ← resets to default and shows table again
  };

  return (
    <div className="bg_home flex flex-col pb-8 h-auto">
      <div className="bg_home md:bg-[#F7F8FA] px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5 h-auto">
        <div className="bg-white w-full rounded-xl shadow-sm md:p-5">
          <div className="">
            <PredictionActions
              onNewPrediction={handleNewPrediction}
              navigate={navigate}
              prediction={prediction}
              handleGoToLivePredictions={handleGoToLivePredictions}
            />
            {prediction?.newPrediction && <PredictionStepper />}
          </div>
          <div className="my-2 text-[12px] text-[#7F8FA4] flex">
            {prediction?.selectCountry?.name && (
              <div className="">{prediction?.selectCountry?.name}</div>
            )}
            {prediction?.electionTypeData?.prediction &&
              prediction?.electionTypeData?.type && (
                <div className="mx-1">
                  {`> ${
                    prediction?.electionTypeData?.prediction
                  }  > ${prediction?.electionTypeData?.type.replace(
                    "_",
                    " "
                  )}`}{" "}
                </div>
              )}
            {prediction?.prediction && (
              <div className="mx-1">{`> ${prediction?.prediction}`}</div>
            )}
            {prediction?.freshPredict && (
              <div className="mx-1">{`> fresh/new prediction > my prediction`}</div>
            )}
          </div>
          
          <div className="mt-3">{renderStep()}</div>
        </div>
      </div>
    </div>
  );
};

export default PredictionListing;
